export default __webpack_public_path__ + "static/media/Microscope.a2fe6eb6.svg";